import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Control, useController } from 'react-hook-form';
import { ExerciseFile } from '../../types';

export interface ExerciseFieldProps {
  control: Control<any>;
  disabled: boolean;
  exercises?: ExerciseFile[] | null;
  loading?: boolean;
  name: string;
}

const ExerciseField = ({ control, disabled, exercises, loading, name }: ExerciseFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules: { required: 'Please select an exercise' } });

  useEffect(() => {
    if (exercises && field.value && !exercises.some(exercise => exercise.id === field.value)) {
      field.onChange(null);
    }
  }, [exercises]);

  const getOptionLabel = optionId => exercises?.find(e => e.id === optionId)?.title ?? '';

  return (
    <Autocomplete
      clearOnBlur
      disableClearable
      disabled={disabled}
      getOptionLabel={getOptionLabel}
      handleHomeEndKeys
      renderOption={(props, optionId) => (
        <li {...props} key={optionId}>
          {getOptionLabel(optionId)}
        </li>
      )}
      options={(exercises ?? []).map(e => e.id)}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          error={!!error}
          helperText={error?.message}
          label="Simulation exercise"
          required
        />
      )}
      {...field}
      onChange={(event, option) => field.onChange(option)}
    />
  );
};

export default ExerciseField;
